import type { Initiative } from '../../api/initiative-client/initiative-client.type';
import type { Goal, Outcome } from '../../api/strategy-client/strategy-client.type';
import type { SimpleEpic, StrategicEpic } from '../../api/tasks-client/task-client.type';

enum StrategyTab {
  Initiatives = 'initiatives',
  Goals = 'goals',
  Outcomes = 'outcomes',
  Epics = 'epics',
  MindMap = 'mind-map',
  Roadmap = 'roadmap',
  Overview = 'overview',
}

enum StrategyEntityType {
  Initiative = 'initiative',
  Goal = 'goal',
  Outcome = 'outcome',
  Epic = 'epic',
}

enum InitiativeState {
  NoEpics = 'no_epics',
  NoEndDate = 'no_end_date',
  Active = 'active',
  Inactive = 'inactive',
}

enum Status {
  Empty = 'empty',
  OffTrack = 'off_track',
  AtRisk = 'at_risk',
  OnTrack = 'on_track',
  Unknown = 'unknown',
}

enum Metric {
  Tasks = 'tasks',
  Points = 'points',
}

type InitiativeRecord = Initiative & {
  contributing_teams_label: string;
};
type StrategyEntity = Initiative | Goal | Outcome | SimpleEpic | StrategicEpic;

export { InitiativeState, Metric, Status, StrategyEntityType, StrategyTab };
export type { InitiativeRecord, StrategyEntity };
